import { Dispatch, SetStateAction } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh, faVolumeXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./PhoneLayers.module.scss";

interface MobileVolumeProps {
  isMobileMuted: boolean;
  setIsMobileMuted: Dispatch<SetStateAction<boolean>>;
  classes?: string;
}

export const MobileVolume = ({
  isMobileMuted,
  setIsMobileMuted,
  classes,
}: MobileVolumeProps) => {
  return (
    <button
      className={`${styles.mobileMuteBtn}${classes ? ` ${classes}` : ""}`}
      onClick={() => setIsMobileMuted(!isMobileMuted)}
    >
      {isMobileMuted ? (
        <FontAwesomeIcon icon={faVolumeXmark} />
      ) : (
        <FontAwesomeIcon icon={faVolumeHigh} />
      )}
    </button>
  );
};
